"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * API error codes
 * To-do: will move to SDK side once it is stable
 * For now keeping in App side as it is easier
 * and does not need SDK publish for small changes
 */
var _default = exports["default"] = {
  TF3004: 'TF3004',
  TF3003: 'TF3003',
  TF3002: 'TF3002',
  TF3001: 'TF3001',
  TF3000: 'TF3000',
  TF3006: 'TF3006',
  // invalid insurance (eg. when u make quote api call)
  TF3009: 'TF3009',
  // invalid booking duration
  TF3005: 'TF3005',
  // invalid add on (eg. when u make quote api call)
  TF3013: 'TF3013',
  // expires quote id
  CM1005: 'CM1005',
  CM1000: 'CM1000',
  // 500 internal server error - Generic Exception!!
  CM1002: 'CM1002',
  CM1008: 'CM1008',
  // 401 - Un Authorized
  CT3000: 'CT3000',
  // OTP not found
  CT3001: 'CT3001',
  // Email already exist
  CT3002: 'CT3002',
  // Invalid Request Id
  CT3003: 'CT3003',
  // Invalid/incorrect OTP
  CT3004: 'CT3004',
  // OTP Expired
  CT3005: 'CT3005',
  // login fail
  CT3009: 'CT3009',
  // Phone already exist
  CT3012: 'CT3012',
  // OTP already sent. Please retry after 30 seconds
  CT3035: 'CT3035',
  // Too many attempts, Please try again after 60 mins.
  BK3012: 'BK3012',
  // invalid or expires quoteID
  BK3019: 'BK3019',
  BK3000: 'BK3000',
  BK3007: 'BK3007',
  // driver not found
  BK3003: 'BK3003',
  BK3015: 'BK3015',
  BK3018: 'BK3018',
  PY3007: 'PY3007',
  // PY3006: 'PY3006',
  PY3001: 'PY3001',
  PY3003: 'PY3003',
  CP3008: 'CP3008',
  CP3024: 'CP3024',
  // Driver already exist”
  CM1009: 'CM1009',
  // Unexpected Guest - when recaptcha verification fails.
  CP3033: 'CP3033',
  // Email Already Exist
  CP3006: 'CP3006',
  // Invalid PromoCode - thrown by Fleet Quote API
  BK5000: 'BK5000',
  // Payment error
  BK5001: 'BK5001',
  // Insufficient funds
  BK5002: 'BK5002',
  // Rejected by bank
  BK5003: 'BK5003',
  // Expired card
  BK5004: 'BK5004',
  // Card not accepted
  BK5005: 'BK5005',
  // OTP error
  BK5006: 'BK5006',
  // Card not accepted
  BK3025: 'BK3025',
  // User is not allowed to book, user is blacklisted
  TF3070: 'TF3070',
  // This Corporate partner has no domain information. Manual verification may be required
  TF3071: 'TF3071' // The domain of the provided email does not match the corporate partner's domain
};